<div class="ui-widget-header" style="padding:4px 10px;border-bottom: 0 none">
  <i class="pi pi-search" style="margin:4px 4px 0 0"></i>

  <input
  size="50"
  placeholder="Najdi uporabnika"
  (input)="dt.filterGlobal($any($event.target).value, 'contains')"
/>
</div>

<p-table
  #dt
  [value]="users"
  [paginator]="true"
  [rows]="10"
  [globalFilterFields]="['id', 'username']"
>
  <!-- HEADER -->
  <ng-template pTemplate="header">
    <tr>
      <th>ID</th>
      <th>Uporabnik</th>
      <th class="col-button">
        <button type="button" pButton icon="pi pi-refresh" (click)="loadUsers()"></button>

        <a class="btn" href="/">
          <button type="button" pButton icon="pi pi-map"></button>
        </a>
      </th>
    </tr>
  </ng-template>

  <!-- BODY -->
  <ng-template pTemplate="body" let-user>
    <tr>
      <td>{{ user.id }}</td>
      <td>{{ user.username }}</td>
      <td class="col-button">
        <button type="button" pButton (click)="addMid(user)" icon="pi pi-plus"></button>
      </td>
    </tr>
  </ng-template>
</p-table>

<p-dialog header="Urejanje občin" [(visible)]="displaypicklist">
  <p-pickList
    [source]="listAllMid"
    [target]="listUserMid"
    [dragdrop]="true"
    (onMoveToSource)="deleteMidFromUser($event)"
    (onMoveToTarget)="addMidToUser($event)"
  >
    <ng-template pTemplate="item" let-obmid>
      <div class="ui-helper-clearfix">
        <div style="font-size:14px;float:right;margin:15px 5px 0 0">
          {{ obmid.label }}
        </div>
      </div>
    </ng-template>
  </p-pickList>
</p-dialog>